import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiValidateCargoBoxesMethod,
    type OpenApiValidateCargoBoxesRequest,
    type OpenApiValidateCargoBoxesResponseSuccess,
    OpenApiValidateCargoBoxesUrl,
} from '#shared/api/schema';

const cargoboxValidateApi = createApi({
    name: 'entities/product/api/cargoboxValidate',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            validateCargoboxes: builder.query<
                OpenApiValidateCargoBoxesResponseSuccess,
                OpenApiValidateCargoBoxesRequest
            >({
                query: (body) => {
                    return {
                        url: OpenApiValidateCargoBoxesUrl,
                        method: OpenApiValidateCargoBoxesMethod,
                        body,
                    };
                },
            }),
        };
    },
});

export const useLazyProductValidateCargoboxes = cargoboxValidateApi.useLazyValidateCargoboxesQuery;
